export default __webpack_public_path__ + "static/media/hero1.e98d08b2.png";